import { apiFetch } from "./client";
import type { HomeQueueResponse, QueueScope } from "./types";

/** NAV-1 badge payload scope — QueueScope plus the all-read tier ('all' is
 *  backend-clamped to an allowed scope when the acting user lacks it). */
export type SummaryScope = QueueScope | "all";

/**
 * F6 Home Unified Action Queue — GET /Custom/frontend/home-summary[?scope=team].
 * Same endpoint as F1 (additive contract); this reads the F6 block only.
 * Backend returns priorityActions ALREADY SORTED by priorityRank — never re-sort.
 */
export function getHomeSummary(
  scope: SummaryScope = "my",
  signal?: AbortSignal,
): Promise<HomeQueueResponse> {
  return apiFetch<HomeQueueResponse>("/Custom/frontend/home-summary", {
    // scope omitted for "my" (backend default); only sent otherwise to keep URLs clean.
    query: scope !== "my" ? { scope } : undefined,
    signal,
  });
}
